/**
 * This script provides the interaction with the SEC filing header by allowing
 * users to toggle the visibility of the document dropdown box. The box can be shown or hidden
 * by clicking on the document links button, clicking outside the box, tabbing out of the box,
 * or pressing Escape.
 *
 * @author Nick Tesh
 */

let filingHeader = document.querySelector("#sec-filing-header");

if (filingHeader) {
    let documentBox = document.querySelector("#sec-filing-header--document-box");
    let documentDetails = document.querySelector("#document-details");
    let sidebar = document.getElementById("scroll_sec_items");
    let indicator = document.getElementById("scrolldown_item");

    function handleScrollIndicator() {
        if (!sidebar || !indicator) {
            return;
        }

        // scrollHeight is the total height of the content. clientHeight is the visible height.
        let isScrollable = sidebar.scrollHeight > sidebar.clientHeight;

        // Use a small buffer to account for fractional pixel scrolling on high-DPI screens
        let distanceToBottom = sidebar.scrollHeight - sidebar.scrollTop - sidebar.clientHeight;
        let isAtBottom = distanceToBottom <= 5;

        if (isScrollable && !isAtBottom) {
            indicator.style.opacity = "1";
        } else {
            indicator.style.opacity = "0";
        }
    }

    // The panel is absolutely positioned below the fixed header, so a static
    // vh-based max-height overshoots the viewport and clips the bottom. Size the
    // scroll area to the actual space between its top and the bottom of the viewport.
    function sizeDocumentBox() {
        if (!sidebar) {
            return;
        }

        let margin = 20; // breathing room above the viewport's bottom edge
        let top = sidebar.getBoundingClientRect().top;
        let available = window.innerHeight - top - margin;

        if (available > 0) {
            sidebar.style.maxHeight = available + "px";
        }
    }

    function openDocumentBox() {
        documentBox.style.display = "block";
        documentDetails.setAttribute("aria-expanded", "true");
        documentDetails.classList.add("open");
        // Measure after the box is visible so position/heights are accurate
        requestAnimationFrame(function() {
            sizeDocumentBox();
            handleScrollIndicator();
        });
    }

    function closeDocumentBox() {
        documentBox.style.display = "none";
        documentDetails.setAttribute("aria-expanded", "false");
        documentDetails.classList.remove("open");
    }

    // Toggle the visibility of the documents links dropdown on click
    documentDetails.addEventListener("click", function() {
        if (documentBox.style.display === "none" || !documentBox.style.display) {
            openDocumentBox();
        } else {
            closeDocumentBox();
        }
    });

    // Hide the documents links dropdown when you click outside of the box
    document.addEventListener("click", function(event) {
        if (!documentBox.contains(event.target) && !documentDetails.contains(event.target) && documentBox.style.display !== "none") {
            closeDocumentBox();
        }
    });

    // Hide the documents links dropdown when you tab outside of the box
    documentBox.addEventListener("focusout", function(event) {
        let isMovingOutOfDocumentBox = !documentBox.contains(event.relatedTarget);
        if (isMovingOutOfDocumentBox) {
            closeDocumentBox();
        }
    });

    // Close the documents links dropdown on Escape and return focus to the trigger
    document.addEventListener("keydown", function(event) {
        if (event.key !== "Escape" || documentBox.style.display === "none" || !documentBox.style.display) {
            return;
        }

        closeDocumentBox();
        documentDetails.focus();
    });

    if (sidebar) {
        sidebar.addEventListener("scroll", handleScrollIndicator);
        window.addEventListener("resize", function() {
            sizeDocumentBox();
            handleScrollIndicator();
        });
    }
}

/**
 * This script checks if the lang attribute is present on the filing HTML element
 * If the lang attribute is not present, it will add it and set it to "en"
 */
 
let htmlElement = document.documentElement;

// Check if the 'lang' attribute is present
if (!htmlElement.hasAttribute('lang')) {
    // Set the 'lang' attribute to 'en'
    htmlElement.setAttribute('lang', 'en');
}